const BUFFERING = 'Buffering...';
const CHANNEL_UNAVAILABLE_MESSAGE =
  'This channel appears to be unavailable at the moment. Please try again later.';
const CANNOT_LOAD_STATIONS_LIST = 'Unable to load stations list';
const HOME_PAGE_TITLE = 'Home';
const SEARCH_PLACEHOLDER =
  'Search (news, music, sports, city, name... or anything else - really!)';

const TOAST_ID = 'loading-audio';

const TUNEIN_STATIONS_URL =
  'https://s3-us-west-1.amazonaws.com/cdn-web.tunein.com/stations.json';

const IPTV_ORG_STATIONS_URL = 'https://iptv-org.github.io/api/channels.json';
const IPTV_ORG_STREAMS_URL = 'https://iptv-org.github.io/api/streams.json';

export {
  BUFFERING,
  CANNOT_LOAD_STATIONS_LIST,
  CHANNEL_UNAVAILABLE_MESSAGE,
  HOME_PAGE_TITLE,
  SEARCH_PLACEHOLDER,
  TOAST_ID,
  TUNEIN_STATIONS_URL,
  IPTV_ORG_STATIONS_URL,
  IPTV_ORG_STREAMS_URL,
};
